<wiz-vgroup padding="10px" width="100%" height="100%" class="section-container">
  <wiz-hgroup width="100%">
    <wiz-label [wizLabel]="'$.widget.configure.look.$'" width="100%" class="smallTitleLabel"></wiz-label>
    <wiz-icon class="image-purple" (click)="hide()">close</wiz-icon>
  </wiz-hgroup>

  <!-- TITLE -->
  <wiz-text-input
    [wizMaxChars]="50"
    wizLabel="$.widget.configure.title.$"
    [wizValue]="widgetTitle"
    (wizChange)="onChangeTitle($event)"
    width="100%"
  ></wiz-text-input>

  <wiz-hgroup  width="100%">
    <wiz-numeric-input #niRowHeight [wizNumber]="rowHeight"
      (wizChange)="onChangeRowHeight($event)"
    wizLabel="$.widget.rowheight.$"></wiz-numeric-input>
    <wiz-numeric-input #niHeadHeight [wizNumber]="headHeight"
      (wizChange)="onChangeHeadHeight($event)"
    wizLabel="$.widget.headheight.$"></wiz-numeric-input>
  </wiz-hgroup>


  

  <!-- FONT COLOR -->
  <wiz-hgroup>
    <wiz-label wizLabel="$.style.css.fontcolor.$" width="100%"></wiz-label>
    <span
      class="wiz-color-picker"
      [style.backgroundColor]="fontColor"
      (click)="showColorPicker($event, 'fontColor')"
      width="20px"
      height="20px"
    ></span>
    <wiz-icon class="wiz-reset-color" (click)="setColorValue('fontColor')">removal</wiz-icon>
  </wiz-hgroup>

  <!-- BACKGROUND COLOR -->
  <wiz-hgroup>
    <wiz-label wizLabel="$.style.css.backgroundcolor.$" width="100%"></wiz-label>
    <span
      class="wiz-color-picker"
      [style.backgroundColor]="backgroundColor"
      (click)="showColorPicker($event, 'backgroundColor')"
      width="20px"
      height="20px"
    ></span>
    <wiz-icon class="wiz-reset-color" (click)="setColorValue('backgroundColor')">removal</wiz-icon>
  </wiz-hgroup>

  <!-- ICON COLOR -->
  <wiz-hgroup>
    <wiz-label wizLabel="$.style.css.iconcolor.$" width="100%"></wiz-label>
    <span
      class="wiz-color-picker"
      [style.backgroundColor]="iconColor"
      (click)="showColorPicker($event, 'iconColor')"
      width="20px"
      height="20px"
    ></span>
    <wiz-icon class="wiz-reset-color" (click)="setColorValue('iconColor')">removal</wiz-icon>
  </wiz-hgroup>

  <wiz-spacer height="20px"></wiz-spacer>

  <wiz-checkbox [wizLabel]="'$.widget.no.border.$'" 
    [wizChecked]='hideBorders' 
    (wizClick)="setHideBorders($event)"></wiz-checkbox>

  
  <wiz-hgroup>
    <wiz-label wizLabel="$.widget.background.radius.$" width="100%"></wiz-label>
    <wiz-numeric-input
    #ni
    [wizNumber]="radius"
    [wizMaxChars]="3"
    wizShowLabel="false"
    nbDecimal="0"
  ></wiz-numeric-input>
  </wiz-hgroup>

  <!-- WIDGET border COLOR -->
  <wiz-hgroup>
    <wiz-label wizLabel="$.widget.border.color.$" width="100%"></wiz-label>
    <span
      class="wiz-color-picker"
      [style.backgroundColor]="widgetBorderColor"
      (click)="showColorPicker($event, 'borderColor')"
      width="20px"
      height="20px"
    ></span>
    <wiz-icon class="wiz-reset-color" (click)="setColorValue('borderColor')">removal</wiz-icon>
  </wiz-hgroup>


  <!-- WIDGET BACKGROUND COLOR -->
  <wiz-hgroup>
    <wiz-label wizLabel="$.widget.background.color.$" width="100%"></wiz-label>
    <span
      class="wiz-color-picker"
      [style.backgroundColor]="widgetBackgroundColor"
      (click)="showColorPicker($event, 'widgetBackgroundColor')"
      width="20px"
      height="20px"
    ></span>
    <wiz-icon class="wiz-reset-color" (click)="setColorValue('widgetBackgroundColor')">removal</wiz-icon>
  </wiz-hgroup>

  <!-- FONT COLOR headers -->
  <wiz-hgroup [visible]="hasColumns">
    <wiz-label wizLabel="$.pivot.column.defaultcolor.$" width="100%"></wiz-label>
    <span
      class="wiz-color-picker"
      [style.backgroundColor]="fontColorH"
      (click)="showColorPicker($event, 'fontColorH')"
      width="20px"
      height="20px"
    ></span>
    <wiz-icon class="wiz-reset-color" (click)="setColorValue('fontColorH')">removal</wiz-icon>
  </wiz-hgroup>

  <!-- BACKGROUND COLOR headers -->
  <wiz-hgroup [visible]="hasColumns">
    <wiz-label wizLabel="$.pivot.column.defaultbackground.$" width="100%"></wiz-label>
    <span
      class="wiz-color-picker"
      [style.backgroundColor]="backgroundColorH"
      (click)="showColorPicker($event, 'backgroundColorH')"
      width="20px"
      height="20px"
    ></span>
    <wiz-icon class="wiz-reset-color" (click)="setColorValue('backgroundColorH')">removal</wiz-icon>
  </wiz-hgroup>



  <wiz-hgroup width="100%" height="100%" horizontalAlign="end" verticalAlign="end">
    <wiz-button wizLabel="$.common.validate.$" [wizDisabled]="!areSettingsValid" (wizClick)="onSave()"></wiz-button>
  </wiz-hgroup>
</wiz-vgroup>
